import checkFitment from './checkFitment.fragment'
import GraphQLRequest from 'Utilities/GraphQLClient/GraphQLClient'

const CheckFitmentForSkuBases = async (skuBases, selectedVehicleId, selectedRaceId) => {
    try {
        if (!skuBases?.length)
            return

        var vehicleBases = []
        var raceTypes = []

        if (selectedVehicleId) {
            vehicleBases.push(selectedVehicleId)
        }
        else if (selectedRaceId)
            raceTypes.push(selectedRaceId)
        else
            return
    
        let variables = {
            skuBases,
            vehicleBases,
            raceTypes
        }

        let response = await GraphQLRequest('/graphql/products', checkFitment, variables)

        return response?.checkFitmentForSkuBases
    } catch (err) {
        console.error("error getting fitment", err);
    }
}

export default CheckFitmentForSkuBases